/**
 * API 错误码 → AlertCard 展示 Hook（筛选器、图表卡片等共用）。
 *
 * 归属 domainComponents/stateDisplay（状态展示适配），不放在 services（避免 service 依赖 React 组件）。
 */
import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';

import AlertCard from '@dbl/components/AlertCard';
import { getErrorText } from '@dbl/services/common';
import type { TResponseError } from '@dbl/services/common';

export const useErrorCard = (
  error: TResponseError | undefined | null,
): React.ReactNode | string | undefined => {
  const { formatMessage, locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;

  return useMemo<React.ReactNode | string | undefined>(() => {
    if (!error) {
      return undefined;
    }

    const content = getErrorText(error, isEn);
    if (content) {
      return React.createElement(AlertCard, {
        title: content.title || '',
        description: content.description,
      });
    }

    return formatMessage({ id: 'common_loading_failed' });
  }, [error?.code, formatMessage, isEn]);
};
